import Vue from "vue";
import {PUT_ACCESS_TOKEN} from "./types";

export default {
    [PUT_ACCESS_TOKEN]  (state, accessToken) {
        Vue.set(state, 'accessToken', accessToken);
    },
};